export default __webpack_public_path__ + "static/media/noperson.1fdc2c3f.png";